import React from "react";
import ETable, {CountBadge, EditIconBtn, YesNoBadge} from "../components/Table";

const TYPE_LABEL = {0: "Brána", 1: "Displej"};

const DeviceTable = ({data}) => {
    const columns = [
        {header: "#ID",                    key: "id"},
        {header: "IP adresa",              key: "ipAddress"},
        {header: "Název",                  key: "name"},
        {header: "Aktivní",                render: row => <YesNoBadge value={row.active === 1}/>},
        {header: "Typ",                    render: row => TYPE_LABEL[row.type] ?? "-"},
        {header: "Port",                   render: row => row.port != null ? row.port : "-"},
        {header: "Spouštět původní akci",  render: row => <YesNoBadge value={row.doDefault === 1}/>},
        {header: "Tarify",                 render: row => <CountBadge value={row?.tariff?.length}/>},
        {header: "Možnosti",               render: row => <EditIconBtn to={"/device/detail/" + row.id}/>},
    ];

    return <ETable columns={columns} data={data}/>;
};

export default DeviceTable;
